module.exports = __webpack_public_path__ + "static/img/materialsax07.b741d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax07.png
// module id = xTs1
// module chunks = 2